import React from "react"
import "./index.css"

const CheckInput = (props: any) => {
    const {
        isToggled = false,
        onToggle = (e: any) => {},
        disabled = false,
    } = props

    const handleToggle = (event: any) => {
        if (!disabled) onToggle(event)
    }

    return (
        <div
            className={`container ${isToggled ? 'on' : 'off'} ${disabled ? 'disabled' : ''}`}
            onClick={handleToggle}
            aria-disabled={disabled}
        >
            <div className={`circle ${isToggled ? 'on' : 'off'}`} onClick={handleToggle} />
        </div>
    )
}

export default CheckInput